/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type WithdrawWorkloadSubjectSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type WithdrawWorkloadSubjectSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type WithdrawWorkloadSubjectSecurity = {
  option1?: WithdrawWorkloadSubjectSecurityOption1 | undefined;
  option2?: WithdrawWorkloadSubjectSecurityOption2 | undefined;
};

export type WithdrawWorkloadSubjectRequest = {
  /**
   * The admission id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type WithdrawWorkloadSubjectSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const WithdrawWorkloadSubjectSecurityOption1$outboundSchema:
  z.ZodMiniType<
    WithdrawWorkloadSubjectSecurityOption1$Outbound,
    WithdrawWorkloadSubjectSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function withdrawWorkloadSubjectSecurityOption1ToJSON(
  withdrawWorkloadSubjectSecurityOption1:
    WithdrawWorkloadSubjectSecurityOption1,
): string {
  return JSON.stringify(
    WithdrawWorkloadSubjectSecurityOption1$outboundSchema.parse(
      withdrawWorkloadSubjectSecurityOption1,
    ),
  );
}

/** @internal */
export type WithdrawWorkloadSubjectSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const WithdrawWorkloadSubjectSecurityOption2$outboundSchema:
  z.ZodMiniType<
    WithdrawWorkloadSubjectSecurityOption2$Outbound,
    WithdrawWorkloadSubjectSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function withdrawWorkloadSubjectSecurityOption2ToJSON(
  withdrawWorkloadSubjectSecurityOption2:
    WithdrawWorkloadSubjectSecurityOption2,
): string {
  return JSON.stringify(
    WithdrawWorkloadSubjectSecurityOption2$outboundSchema.parse(
      withdrawWorkloadSubjectSecurityOption2,
    ),
  );
}

/** @internal */
export type WithdrawWorkloadSubjectSecurity$Outbound = {
  Option1?: WithdrawWorkloadSubjectSecurityOption1$Outbound | undefined;
  Option2?: WithdrawWorkloadSubjectSecurityOption2$Outbound | undefined;
};

/** @internal */
export const WithdrawWorkloadSubjectSecurity$outboundSchema: z.ZodMiniType<
  WithdrawWorkloadSubjectSecurity$Outbound,
  WithdrawWorkloadSubjectSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => WithdrawWorkloadSubjectSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => WithdrawWorkloadSubjectSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function withdrawWorkloadSubjectSecurityToJSON(
  withdrawWorkloadSubjectSecurity: WithdrawWorkloadSubjectSecurity,
): string {
  return JSON.stringify(
    WithdrawWorkloadSubjectSecurity$outboundSchema.parse(
      withdrawWorkloadSubjectSecurity,
    ),
  );
}

/** @internal */
export type WithdrawWorkloadSubjectRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const WithdrawWorkloadSubjectRequest$outboundSchema: z.ZodMiniType<
  WithdrawWorkloadSubjectRequest$Outbound,
  WithdrawWorkloadSubjectRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function withdrawWorkloadSubjectRequestToJSON(
  withdrawWorkloadSubjectRequest: WithdrawWorkloadSubjectRequest,
): string {
  return JSON.stringify(
    WithdrawWorkloadSubjectRequest$outboundSchema.parse(
      withdrawWorkloadSubjectRequest,
    ),
  );
}
